import styled from "styled-components";

export const Container = styled.div`
    background-color: #FFEDD1;
    padding: 8px 12px;
    margin-bottom: 10px;
    font-size: 14px;
    line-height: 20px;
    color: #000;
    width: ${p => p.width ? p.width : '100%'};
    border-radius: 4px;
    ${p => p.inline && `
        display: inline-flex;
        align-self: flex-start;
    `}
`;